<template>
  <div v-if="showButton">
    <p class="mt-4" v-html="message"/>
    <p class="text-center">
      <template v-if="showGoogleButton">
        <a :href="googleUrl" class="wallet-pass-button" target="_blank">
          <img src="../../../assets/img/wallet-pass/google/enUS_add_to_google_wallet_wallet-button.svg"
            alt="Add to Google Wallet" width="283px" height="50px">
        </a>
      </template>
      <template v-if="showAppleButton">
        <a :href="appleUrl" class="wallet-pass-button">
          <img src="../../../assets/img/wallet-pass/apple/US_UK/RGB/US-UK_Add_to_Apple_Wallet_RGB_101421.svg" alt="Add to Apple Wallet"
            width="193px" height="61px">
        </a>
      </template>
    </p>
  </div>
</template>

<script>

import { isIOS, isSafari, isAndroid, isChrome } from '../../../lib/device';

export default {
  props: {
    message: {
      type: String,
      required: false,
    },
    plasticCard: {
      type: Object,
      required: true,
    },
  },
  computed: {
    enabledButtons() {
      return (process.env.ENABLED_WALLET_PASS_BUTTONS || '').split(',').map((button) => button.trim());
    },
    showAppleButton() {
      if (!this.enabledButtons.includes('apple')) {
        return false;
      }
      return isIOS() || isSafari();
    },
    showGoogleButton() {
      if (!this.enabledButtons.includes('google')) {
        return false;
      }
      return isAndroid() || isChrome();
    },
    showButton() {
      return this.showAppleButton || this.showGoogleButton
    },
    currentMembership() {
      return this.$store.getters.currentUser && this.$store.getters.currentUser.membership
    },
    googleUrl() {
      return `${process.env.PASS_APP_URL}google-pass?code=${this.plasticCard.code}&v${Date.now()}`;
    },
    appleUrl() {
      return `${process.env.PASS_APP_URL}apple-pass?code=${this.plasticCard.code}&v${Date.now()}`;
    },
  },
  methods: {
    googlePass() {
      window.open(this.googleUrl, '_blank');
    },
    applePass() {
      window.open(this.appleUrl, '_blank');
    },
  },
  components: {
  }
}
</script>

<style lang="scss" scoped>
.wallet-pass-button {
  cursor: pointer;
  padding: 16px 0;
}
</style>